import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { actionable, ads, area, bill, dashboard, growth, logo,footerLogo, market, refer, sales, suggestions, support, time, dashboardfill, adsfill, actionablefill, areafill, timefill, salesfill, marketfill, suggestionsfill, referfill, billfill, supportfill, } from '../../../../images/index.js'

const Sidebar = ({ handleOpen, disableAll }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const [openSection, setOpenSection] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);

  const isMobile = () => window.innerWidth < 1203;

  const isActive = (path) => currentPath === path;
  const isSubRouteActive = (prefix) => currentPath.startsWith(prefix);

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");


  //  Reactively watch for theme changes in localStorage
  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = localStorage.getItem("theme") || "light";
      setTheme(newTheme);
    };

    // Listen for theme changes from anywhere in the app
    window.addEventListener("storage", handleThemeChange);

    // Optional: for in-app theme toggle (custom event)
    window.addEventListener("themeChanged", handleThemeChange);

    return () => {
      window.removeEventListener("storage", handleThemeChange);
      window.removeEventListener("themeChanged", handleThemeChange);
    };
  }, []);


  useEffect(() => {
    if (isSubRouteActive("/area-wise-insights")) {
      setOpenSection("components");
    } else {
      setOpenSection("");
    }
  }, [currentPath]);

  const toggleSection = (section) => {
    if (section === "components") {
      navigate("/area-wise-insights");
    }
    setOpenSection(openSection === section ? "" : section);
  };

  const handleSidebarToggle = () => {
    if (!isMobile()) {
      document.body.classList.toggle("toggle-sidebar");
      setIsCollapsed(!isCollapsed);
    }
  };

  const handleSidebarToggleOnMobile = () => {
    if (isMobile()) {
      document.body.classList.remove("toggle-sidebar");
      setIsCollapsed(false);
    }
  };

  return (
    <aside id="sidebar" className={`sidebar d-flex flex-column ${isCollapsed ? "collapsed" : ""}`}>
      {/* Sidebar Header */}
      <div className="d-flex align-items-center justify-content-between px-2">
        <i
          className="bi bi-list toggle-sidebar-btn"
          onClick={handleSidebarToggle}
        ></i>

        {!isCollapsed && <a href="/dashboard" className="logo gapalyze-logo d-flex align-items-center" style={{ height: "50px" }}>
          <img
            src={(theme === "dark") ? footerLogo : logo}
            alt="Gapalyze Logo"
            className={(theme === "dark")?"logo-sidebar-image-dark":"logo-sidebar-image"}
          />
        </a>}
      </div>

      {/* Scrollable Nav Section */}
      <div className="flex-grow-1 overflow-auto " style={{ maxHeight: "calc(100vh - 100px)", scrollbarWidth: "none" }}>
        <ul className="sidebar-nav" id="sidebar-nav">
          <SidebarItem disabled={disableAll} to="/dashboard" imageSrc={isActive("/dashboard") ? dashboardfill : dashboard} label={t("sidebar.dashboardHome")} isActive={isActive("/dashboard")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/ad-insights" imageSrc={isActive("/ad-insights") ? adsfill : ads} label={t("sidebar.adsAnalysis")} isActive={isActive("/ad-insights")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/ad-keywords" imageSrc={isActive("/ad-keywords") ? adsfill : ads} label={t("sidebar.searchKeywords")} isActive={isActive("/ad-keywords")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/seller-radar" imageSrc={isActive("/seller-radar") ? actionablefill : actionable} label={t("sidebar.actionableCondition")} isActive={isActive("/seller-radar")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/area-wise-insights" imageSrc={isActive("/area-wise-insights") ? areafill : area} label={t("sidebar.regionalLevelSales")} isActive={isActive("/area-wise-insights")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/time-lens" imageSrc={isActive("/time-lens") ? timefill : time} label={t("sidebar.timeSalesAnalysis")} isActive={isActive("/time-lens")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem to="/order" icon="bi-bag-check" label={t("sidebar.order")} isActive={isActive("/order")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/product-growth" imageSrc={growth} label={t("sidebar.productGrowth")} isActive={isActive("/product-growth")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/interactive-sales-map" imageSrc={isActive("/interactive-sales-map") ? salesfill : sales} label={t("sidebar.interactiveSalesMap")} isActive={isActive("/interactive-sales-map")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem disabled={disableAll} to="/marketplace-accounts" imageSrc={isActive("/marketplace-accounts") ? marketfill : market} label={t("sidebar.marketPlaceAccounts")} isActive={isActive("/marketplace-accounts")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem to="/suggestion-portal" imageSrc={isActive("/suggestion-portal") ? suggestionsfill : suggestions} label={t("sidebar.discussionBox")} isActive={isActive("/suggestion-portal")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem to="/referral" imageSrc={isActive("/referral") ? referfill : refer} label={t("sidebar.referal")} isActive={isActive("/referral")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          {/*<SidebarItem to="/show-ticket" icon="bi-ticket-perforated" label={t("sidebar.supportTicket")} isActive={isActive("/show-ticket")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />*/}
          <SidebarItem to="/billing-section" imageSrc={isActive("/billing-section") ? billfill : bill} label={t("sidebar.billingSection")} isActive={isActive("/billing-section") || isSubRouteActive("/billing-section")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />
          <SidebarItem to="/ticket" imageSrc={isActive("/ticket") ? supportfill : support} label={t("sidebar.supportTicket")} isActive={isActive("/ticket")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />

          {/*<SidebarItem to="/review-rating" icon="bi-chat-left-text" label={t("sidebar.reviewRating")} isActive={isActive("/review-rating")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />*/}
          {/*<SidebarItem to="/geographical-sales-insights" icon="bi-globe" label={t("sidebar.geographicalSalesInsights")} isActive={isActive("/geographical-sales-insights")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />*/}
          {/*<SidebarItem to="/products" icon="bi-graph-up-arrow" label={t("sidebar.products")} isActive={isActive("/products")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />*/}
          {/*<SidebarItem to="/report-processing" icon="bi-file-earmark-bar-graph" label={t("sidebar.reportProcessing")} isActive={isActive("/report-processing")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />*/}
          {/*<SidebarItem to="/settings" icon="bi-gear" label={t("sidebar.Settings")} isActive={isActive("/settings")} isCollapsed={isCollapsed} onLinkClick={handleSidebarToggleOnMobile} />*/}

        </ul>
      </div>

      {/* Fixed Bottom Rating Icon */}
      <div className="sidebar-rating-section p-3 border-top">
        <div
          role="button"
          className="d-flex align-items-center text-decoration-none"
          onClick={handleOpen}
        >
          <i className="bi bi-star-fill me-2 text-warning"></i>
          {!isCollapsed && <span>{t("sidebar.rateUs") || "Rate Us"}</span>}
        </div>
      </div>
    </aside>
  );
};

// Reusable Sidebar Item
const SidebarItem = ({ to, icon, imageSrc, label, isActive, isCollapsed, onLinkClick, disabled }) => (
  <li className={`nav-item ${isActive ? "active" : ""} ${disabled ? "disabled-sidebar-item" : ""
    }`}>
    <Link
      className="nav-link"
      to={to}
      onClick={() => {
        if (onLinkClick) onLinkClick();
      }}
    >
      {imageSrc ? (
        <img src={imageSrc} alt={label || "Sidebar logo"} style={{ width: '20px', height: '20px', marginRight: '8px' }} />
      ) : (
        <i className={`bi ${icon}`} style={{ fontSize: '20px', marginRight: '10px', color: '#362bdf' }}></i>
      )}
      {!isCollapsed && <span>{label}</span>}
    </Link>
  </li>
);

export default Sidebar;
